import { render, staticRenderFns } from "./ParentsFeedback.vue?vue&type=template&id=f35a6328&scoped=true"
import script from "./ParentsFeedback.vue?vue&type=script&lang=js"
export * from "./ParentsFeedback.vue?vue&type=script&lang=js"
import style0 from "./ParentsFeedback.vue?vue&type=style&index=0&id=f35a6328&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35a6328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f35a6328')) {
      api.createRecord('f35a6328', component.options)
    } else {
      api.reload('f35a6328', component.options)
    }
    module.hot.accept("./ParentsFeedback.vue?vue&type=template&id=f35a6328&scoped=true", function () {
      api.rerender('f35a6328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/ParentsFeedback.vue"
export default component.exports